import React from "react";
import { Input } from "antd";

const MyInput = ({ data, setAnswer }) => {
  const placeholder = {
    input: "Free Entry",
    number: "Number",
    email: "Email Address",
  };

  const onBlur = (event) => {
    const value =
      data?.field_type === "email"
        ? event?.target?.value?.toLowerCase()
        : event?.target?.value;
    setAnswer(value);
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-start gap-2">
        {data?.is_required === 1 && <p className="text-red-600 text-lg">*</p>}
        <p className="text-base text-center">{data?.field_label}</p>
      </div>

      <Input
        className="py-3 ps-4 w-full"
        size="large"
        type={data?.field_type}
        min={0}
        placeholder={placeholder[data?.field_type]}
        defaultValue={data?.response_text}
        onBlur={onBlur}
      />
    </div>
  );
};

export default MyInput;
